import { isApiErrorResponse } from 'shared';

import { showSnackbar } from './snackbar';

export interface WrapRequestOptions<T> {
  successMessage?: string;
  errorMessage?: string;
  showSuccessMessage?: boolean;
  showErrorMessage?: boolean;
  onSuccess?: (response: T) => void;
  onError?: (error: any) => void;
  onFinally?: () => void;
  position?: 'left' | 'center' | 'top';
}

export async function wrapRequest<T>(
  request: Promise<T>,
  {
    successMessage,
    errorMessage,
    showSuccessMessage = true,
    showErrorMessage = true,
    onSuccess,
    onError,
    onFinally,
    position
  }: WrapRequestOptions<T> = {}
) {
  try {
    const response = await request;
    if (showSuccessMessage) {
      showSnackbar({
        message: successMessage,
        position
      });
    }
    onSuccess?.(response);
    return response;
  } catch (error) {
    let message: string | undefined;

    if (errorMessage) {
      message = errorMessage;
    } else if (isApiErrorResponse(error)) {
      message = error.message;
    }

    if (showErrorMessage) {
      showSnackbar({
        message,
        negative: true,
        position
      });
    }
    onError?.(error);
    throw error;
  } finally {
    onFinally?.();
  }
}
